import { render, staticRenderFns } from "./MultiSelectFormItem.vue?vue&type=template&id=6e4c2cd2&scoped=true"
import script from "./MultiSelectFormItem.vue?vue&type=script&lang=js"
export * from "./MultiSelectFormItem.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectFormItem.vue?vue&type=style&index=0&id=6e4c2cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4c2cd2",
  null
  
)

export default component.exports